import './shared/formValidation/formValidation'
import '../styles/shared/_forms.css'

(() => {

    $('.js-form').validateForm({
        showConfirmOnSuccess: false,
        requiredMsg: 'هذا الحقل إجباري!',
        emailValidationMsg: 'بريد إلكتروني خاطئ!',
        successPopUpTitle: application.translations.confirmation,
        okPopUpBtnText: application.translations.ok,
        checkRequired: true,
        scrollToFirstError: true,
        scrollMargin: 138,
    });

})();
